<div fxLayout="row" fxLayout.lt-md="column" class="profile-details-container" #progressContainer>
  <div fxLayout="column" fxFlex="48%" class="profile-details-block">
    <div *ngIf="school">
      <school-details [school]="school" [grade]="grade"></school-details>

      <div class="save-actions full-width">
        <div class="fill-space"></div>
        <app-button color="primary"
                    width="172px"
                    label="Change School"
                    i18n-label="User Profile|User profile change school button label@@user-profile-change-school-button-label"
                    (clicked)="updateSchool()"></app-button>
      </div>
    </div>
  </div>

  <div class="fill-space"></div>
</div>
